import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-link-redirect',
  templateUrl: './reset-link-redirect.component.html',
  styleUrl: './reset-link-redirect.component.scss'
})
export class ResetLinkRedirectComponent {
  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const userIdentifier = params['userIdentifier'];
      const code = params['code'];

      this.router.navigate(['auth/forgot-password'], { queryParams: { userIdentifier, code } });
    });
  }
}
